import React, { useCallback } from 'react';

import { INSTRUCTOR_CATEGORIES } from '@classCreation/data/instructorCategories';
import InstructorSelect from 'components/InstructorSelect';

export default function SbatGroupSecondaryInstructorSelect({
  onInstructorsChange,
  ...remainingProps
}) {
  const handleInstructorsChange = useCallback(
    (newInstructor) => {
      onInstructorsChange((prevInstructors) => ({
        ...prevInstructors,
        [INSTRUCTOR_CATEGORIES.secondary]: newInstructor,
      }));
    },
    [onInstructorsChange]
  );

  return (
    <InstructorSelect
      {...remainingProps}
      placeholder="Select Secondary Instructor"
      onChange={handleInstructorsChange}
    />
  );
}
